export enum ReportsModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
